// Auth Model - State Managers  
// Auth 상태 관리 유틸리티들
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/**
 * Auth 상태 관리 유틸리티
 */ export var AuthStateManager = /*#__PURE__*/ function() {
    "use strict";
    function AuthStateManager() {
        _class_call_check(this, AuthStateManager);
    }
    _create_class(AuthStateManager, null, [
        {
            key: "createAuthState",
            value: /**
   * 통합 Auth 상태 생성
   */ function createAuthState(user, tokens, session) {
                var loading = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, error = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
                return {
                    isAuthenticated: !!user && !!tokens && !this.isTokenExpired(tokens),
                    isLoading: loading,
                    error: error,
                    user: user,
                    token: (tokens === null || tokens === void 0 ? void 0 : tokens.accessToken) || null,
                    refreshToken: (tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken) || null,
                    tokens: tokens,
                    session: session
                };
            }
        },
        {
            key: "isTokenExpired",
            value: /**
   * 토큰 만료 확인
   */ function isTokenExpired(tokens) {
                if (!tokens || !tokens.expiresAt) return false;
                var now = new Date();
                var expiresAt = new Date(tokens.expiresAt);
                var bufferTime = 5 * 60 * 1000; // 5분 버퍼
                return now.getTime() >= expiresAt.getTime() - bufferTime;
            }
        },
        {
            key: "isSessionActive",
            value: /**
   * 세션 활성 상태 확인
   */ function isSessionActive(session) {
                if (!session) return false;
                var now = new Date();
                var expiresAt = new Date(session.expiresAt);
                return session.isActive && now < expiresAt;
            }
        },
        {
            key: "hasRole",
            value: /**
   * 사용자 권한 확인
   */ function hasRole(user, role) {
                var _user_roles;
                var _user_roles_includes;
                return (_user_roles_includes = user === null || user === void 0 ? void 0 : (_user_roles = user.roles) === null || _user_roles === void 0 ? void 0 : _user_roles.includes(role)) !== null && _user_roles_includes !== void 0 ? _user_roles_includes : false;
            }
        },
        {
            key: "hasPermission",
            value: /**
   * 사용자 권한 확인
   */ function hasPermission(user, permission) {
                var _user_permissions;
                var _user_permissions_includes;
                return (_user_permissions_includes = user === null || user === void 0 ? void 0 : (_user_permissions = user.permissions) === null || _user_permissions === void 0 ? void 0 : _user_permissions.includes(permission)) !== null && _user_permissions_includes !== void 0 ? _user_permissions_includes : false;
            }
        },
        {
            key: "getTimeUntilExpiry",
            value: /**
   * 토큰 만료까지 남은 시간 (초)
   */ function getTimeUntilExpiry(tokens) {
                if (!tokens || !tokens.expiresAt) return 0;
                var now = new Date();
                var expiresAt = new Date(tokens.expiresAt);
                return Math.max(0, Math.floor((expiresAt.getTime() - now.getTime()) / 1000));
            }
        }
    ]);
    return AuthStateManager;
}();
/**
 * Auth 이벤트 관리자
 */ export var AuthEventManager = /*#__PURE__*/ function() {
    "use strict";
    function AuthEventManager() {
        _class_call_check(this, AuthEventManager);
    }
    _create_class(AuthEventManager, null, [
        {
            key: "addEventListener",
            value: /**
   * 이벤트 리스너 등록
   */ function addEventListener(type, listener) {
                if (!this.listeners.has(type)) {
                    this.listeners.set(type, new Set());
                }
                this.listeners.get(type).add(listener);
            }
        },
        {
            key: "removeEventListener",
            value: /**
   * 이벤트 리스너 제거
   */ function removeEventListener(type, listener) {
                var listeners = this.listeners.get(type);
                if (listeners) {
                    listeners.delete(listener);
                }
            }
        },
        {
            key: "dispatchEvent",
            value: /**
   * 이벤트 발생
   */ function dispatchEvent(event) {
                var listeners = this.listeners.get(event.type);
                if (listeners) {
                    listeners.forEach(function(listener) {
                        try {
                            listener(event);
                        } catch (error) {
                            console.error('Auth event listener error:', error);
                        }
                    });
                }
            }
        },
        {
            key: "dispatchLoginSuccess",
            value: /**
   * 로그인 성공 이벤트 발생
   */ function dispatchLoginSuccess(userId, provider) {
                this.dispatchEvent({
                    type: 'auth:login',
                    timestamp: Date.now(),
                    data: {
                        userId: userId,
                        provider: provider
                    },
                    source: 'web'
                });
            }
        },
        {
            key: "dispatchLogout",
            value: /**
   * 로그아웃 이벤트 발생
   */ function dispatchLogout(userId) {
                this.dispatchEvent({
                    type: 'auth:logout',
                    timestamp: Date.now(),
                    data: {
                        userId: userId
                    },
                    source: 'web'
                });
            }
        },
        {
            key: "dispatchAuthError",
            value: /**
   * 인증 에러 이벤트 발생
   */ function dispatchAuthError(error, userId) {
                this.dispatchEvent({
                    type: 'auth:error',
                    timestamp: Date.now(),
                    data: {
                        userId: userId,
                        error: error
                    },
                    source: 'web'
                });
            }
        }
    ]);
    return AuthEventManager;
}();
_define_property(AuthEventManager, "listeners", new Map());
/**
 * Storage 관리자 (토큰 저장)
 */ export var AuthStorageManager = /*#__PURE__*/ function() {
    "use strict";
    function AuthStorageManager() {
        _class_call_check(this, AuthStorageManager);
    }
    _create_class(AuthStorageManager, null, [
        {
            key: "saveTokens",
            value: /**
   * 토큰 저장
   */ function saveTokens(tokens) {
                try {
                    localStorage.setItem(this.ACCESS_TOKEN_KEY, tokens.accessToken);
                    if (tokens.refreshToken) {
                        localStorage.setItem(this.REFRESH_TOKEN_KEY, tokens.refreshToken);
                    }
                } catch (error) {
                    console.error('Failed to save tokens:', error);
                }
            }
        },
        {
            key: "loadTokens",
            value: /**
   * 토큰 로드
   */ function loadTokens() {
                try {
                    var accessToken = localStorage.getItem(this.ACCESS_TOKEN_KEY);
                    var refreshToken = localStorage.getItem(this.REFRESH_TOKEN_KEY);
                    if (!accessToken) return null;
                    return {
                        accessToken: accessToken,
                        refreshToken: refreshToken || undefined,
                        tokenType: 'Bearer',
                        expiresAt: Date.now() + 3600000,
                        issuedAt: Date.now()
                    };
                } catch (error) {
                    console.error('Failed to load tokens:', error);
                    return null;
                }
            }
        },
        {
            key: "saveUser",
            value: /**
   * 사용자 정보 저장
   */ function saveUser(user) {
                try {
                    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
                } catch (error) {
                    console.error('Failed to save user:', error);
                }
            }
        },
        {
            key: "loadUser",
            value: /**
   * 사용자 정보 로드
   */ function loadUser() {
                try {
                    var userJson = localStorage.getItem(this.USER_KEY);
                    return userJson ? JSON.parse(userJson) : null;
                } catch (error) {
                    console.error('Failed to load user:', error);
                    return null;
                }
            }
        },
        {
            key: "clearAll",
            value: /**
   * 모든 Auth 데이터 삭제
   */ function clearAll() {
                try {
                    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
                    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
                    localStorage.removeItem(this.USER_KEY);
                    localStorage.removeItem(this.SESSION_KEY);
                } catch (error) {
                    console.error('Failed to clear auth data:', error);
                }
            }
        }
    ]);
    return AuthStorageManager;
}();
_define_property(AuthStorageManager, "ACCESS_TOKEN_KEY", 'auth:access_token');
_define_property(AuthStorageManager, "REFRESH_TOKEN_KEY", 'auth:refresh_token');
_define_property(AuthStorageManager, "USER_KEY", 'auth:user');
_define_property(AuthStorageManager, "SESSION_KEY", 'auth:session');
